import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// Components
import NotificationPanel from "./NotificationPanel";

// Actions
import {
  fetchNotifications,
  fetchUnreadCount
} from "../../redux/actions/notifications.actions";

const POLL_INTERVAL_MS = 60000;

/**
 * Mounted once in AppShell: keeps the unread badge fresh (poll + window
 * focus) and renders the notification panel when it's open.
 */
const NotificationCenter = () => {
  const dispatch = useDispatch();
  const { panelOpen } = useSelector(state => state.notifications);
  const { auth } = useSelector(state => state.app);
  const token = auth?.token;

  useEffect(() => {
    if (!token) return;

    dispatch(fetchUnreadCount());

    const interval = setInterval(
      () => dispatch(fetchUnreadCount()),
      POLL_INTERVAL_MS
    );
    const onFocus = () => dispatch(fetchUnreadCount());
    window.addEventListener("focus", onFocus);

    return () => {
      clearInterval(interval);
      window.removeEventListener("focus", onFocus);
    };
  }, [token, dispatch]);

  useEffect(() => {
    if (panelOpen) {
      dispatch(fetchNotifications());
      dispatch(fetchUnreadCount());
    }
  }, [panelOpen, dispatch]);

  if (!panelOpen) return null;

  return <NotificationPanel />;
};

export default NotificationCenter;
